package com.ijoin.data.repository

import com.ijoin.data.api.UserApi
import com.ijoin.data.model.UserFollowState
import com.ijoin.data.model.UserProfile

class UserRepository(
    private val userApi: UserApi = UserApi()
) {
    suspend fun getUserProfile(userId: String): Result<UserProfile> = userApi.getUserProfile(userId)
    suspend fun follow(userId: String): Result<UserFollowState> = userApi.followUser(userId)
    suspend fun unfollow(userId: String): Result<UserFollowState> = userApi.unfollowUser(userId)
    suspend fun getFollowingUsers(userId: String) = userApi.getFollowingUsers(userId)
}
